import { Observable } from 'rxjs';
import { DataSourceResponse, EmailSetting } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';

@Injectable({ providedIn: 'root' })
export class EmailSettingService extends ApiService {
    endPoint = '/api/email-setting';
    create(model: EmailSetting) {
        return this.http.post(`${this.notificationBaseUrl}${this.endPoint}`, model);
    }

    update(model: EmailSetting) {
        return this.http.put(`${this.notificationBaseUrl}${this.endPoint}`, model);
    }

    delete(id: string) {
        return this.http.delete<any>(`${this.notificationBaseUrl}${this.endPoint}/${id}`);
    }

    get(id: string): Observable<EmailSetting> {
        return this.http.get<EmailSetting>(`${this.notificationBaseUrl}${this.endPoint}/${id}`);
    }

    getList(queryParams: any): Observable<DataSourceResponse<EmailSetting>> {
        const params = new HttpParamsEncoder().encode(queryParams);
        return this.http.get<any>(`${this.notificationBaseUrl}${this.endPoint}`, { params });
    }
}
